export function adobeTrackEvent({
  eventName, // "click-event", "exit-event", or "download-event"
  label,
  title = "",
  category,
  subSection,
  targetUrl = "",
  type = "button",
}) {
  const trackingData = {
    event: eventName,
    event_metadata: {
      action_type: type,
      action_label: label,
      action_category: category,
      download_title: title,
    },
    metadata: {
      target_url: targetUrl,
      error_field: "",
      error_display_message: "",
    },
    page: {
      sub_section: subSection,
      page_friendly_url:
        eventName === "click-event" && targetUrl
          ? targetUrl
          : window.location.href,
      full_url:
        eventName === "click-event" && targetUrl
          ? targetUrl
          : window.location.href,
      page_name: "motocompacto:landing page",
      property_name: "motocompacto",
      site_language_code: "en",
      site_section: "honda motocompacto",
      brand_name: "honda",
      environment:
        typeof adobeEnvironment === "function" ? adobeEnvironment() : "",
      internal_referrer:
        typeof adobeInternalReferrer === "function"
          ? adobeInternalReferrer()
          : "",
      referrer_type:
        typeof adobeReferrerType === "function" ? adobeReferrerType() : "",
      referrer_url: document.referrer || "",
    },
    user: {
      cookie_consent_category: "",
      request_duration: "",
      request_number: "",
      user_zipcode: "",
      user_status: "",
    },
  };
  window.digitalData.push(trackingData);
}

export function adobeReferrerType() {
  const docReferrer = document.referrer;
  const referrer_types = {
    bookmarked: "typed/bookmarked",
    social: "social_network",
    search: "search_engine",
    internal: "internal",
    other: "external",
  };

  const social_media = [
    "facebook.com",
    "linkedin.com",
    "twitter.com",
    "plus.google.com",
    "orkut.com",
    "friendster.com",
    "livejournal.com",
    "blogspot.com",
    "wordpress.com",
    "friendfeed.com",
    "myspace.com",
    "digg.com",
    "reddit.com",
    "stumbleupon.com",
    "twine.com",
    "yelp.com",
    "mixx.com",
    "delicious.com",
    "tumblr.com",
    "disqus.com",
    "intensedebate.com",
    "plurk.com",
    "slideshare.net",
    "backtype.com",
    "netvibes.com",
    "mister-wong.com",
    "diigo.com",
    "flixster.com",
    "youtube.com",
    "vimeo.com",
    "12seconds.tv",
    "zooomr.com",
    "identi.ca",
    "jaiku.com",
    "flickr.com",
    "imeem.com",
    "dailymotion.com",
    "photobucket.com",
    "fotolog.com",
    "smugmug.com",
    "classmates.com",
    "myyearbook.com",
    "mylife.com",
    "tagged.com",
    "brightkite.com",
    "ning.com",
    "bebo.com",
    "hi5.com",
    "yuku.com",
    "cafemom.com",
    "xanga.com",
    "tiktok.com",
    "snapchat.com",
    "instagram.com",
    "pinterest.com",
  ];

  const search_engines = [
    "google.com",
    "yandex.com",
    "bing.com",
    "yahoo.com",
    "aol.com",
    "duckduckgo.com",
    "naver.com",
    "baidu.com",
    "ask.com",
    "ecosia.com",
    "internetarchive.com",
    "yep.com",
    "bravesearch.com",
    "perplexityai.com",
    "you.com",
  ];

  if (!docReferrer) return referrer_types.bookmarked;
  if (/honda/i.test(docReferrer)) return referrer_types.internal;
  if (social_media.some((site) => docReferrer.includes(site)))
    return referrer_types.social;
  if (search_engines.some((site) => docReferrer.includes(site)))
    return referrer_types.search;
  return referrer_types.other;
}

export function adobeInternalReferrer() {
  const docReferrer = document.referrer;
  if (!docReferrer) return "";
  //if (/honda/i.test(docReferrer)) return docReferrer;
  return "";
}

export function adobeEnvironment() {
  try {
    // 1. Find the script tag using a more specific CSS selector
    const launchScript = Array.from(
      document.querySelectorAll('script[src*="assets.adobedtm.com"]'),
    ).find((script) => script.src.includes("launch-"));

    let id = "";
    if (launchScript) {
      // 2. Clean the URL and grab the last 5 characters
      id = launchScript.src
        .replace(/\.min\.js/g, "")
        .replace(/-(development|staging)/g, "")
        .slice(-5);
    }

    // 3. Safely access _satellite and use template literals
    const adobeStage = window._satellite?.environment?.stage || "unknown";
    const appEnv = process.env.REACT_APP_ADOBE_ENV || "unknown";

    return `${appEnv}|${id}(${adobeStage})`;
  } catch (error) {
    console.error("Adobe Environment Detection Error:", error);
    return "";
  }
}
